enum BookType {
    books = 'books',
    administration = 'administration'
}

export default BookType;